import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../../common/flex-options/flex-options.esm.js';
import cardCommon from '../common/index.esm.js';

var cardBodyTV = getTvObject({
  base: [].concat(_toConsumableArray(flexOptions.base), ['print:px-0']),
  variants: _objectSpread2(_objectSpread2({}, flexOptions.variants), {}, {
    padding: cardCommon.padding,
    withDivider: {
      "true": [],
      "false": []
    }
  }),
  compoundVariants: [].concat(_toConsumableArray(flexOptions.compoundVariants), [{
    direction: 'horizontal',
    withDivider: false,
    className: []
  }, {
    direction: 'vertical',
    withDivider: false,
    className: ['py-0']
  }])
});
var base = tv(cardBodyTV);
var cardBodyStyles = {
  base: base
};

export { cardBodyStyles, cardBodyTV };
//# sourceMappingURL=card-body.styles.esm.js.map
